import {
  FETCH_EVALUATIONS_REQUEST,
  FETCH_EVALUATIONS_SUCCESS,
  FETCH_EVALUATIONS_FAILURE,
  SAVE_EVALUATION_REQUEST,
  SAVE_EVALUATION_SUCCESS,
  SAVE_EVALUATION_FAILURE,
  CHANGE_EVALUATION_STATUS_REQUEST,
  CHANGE_EVALUATION_STATUS_SUCCESS,
  CHANGE_EVALUATION_STATUS_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  evaluationsList: [],
  data: null,
  error: null,
  success: false,
};

const evaluationMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EVALUATIONS_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case FETCH_EVALUATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        evaluationsList: action.payload.data || [],
        success: false,
      };

    case FETCH_EVALUATIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case SAVE_EVALUATION_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case SAVE_EVALUATION_SUCCESS:
      return { ...state, loading: false, data: action.payload, success: true };

    case SAVE_EVALUATION_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CHANGE_EVALUATION_STATUS_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case CHANGE_EVALUATION_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };

    case CHANGE_EVALUATION_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default evaluationMasterReducer;
